/**
 * API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ChatReportStatus } from '../model/chatReportStatus';
import { GetBlockedUsersResult } from '../model/getBlockedUsersResult';
import { GetChatReportsResult } from '../model/getChatReportsResult';
import { GetFriendCountResult } from '../model/getFriendCountResult';
import { GetFriendRequestsResult } from '../model/getFriendRequestsResult';
import { GetFriendsResult } from '../model/getFriendsResult';
import { GetPresenceResult } from '../model/getPresenceResult';
import { GetReportConversationMessagesResult } from '../model/getReportConversationMessagesResult';
import { ReportUserCommand } from '../model/reportUserCommand';
import { SearchFriendsResult } from '../model/searchFriendsResult';
import { SendFriendRequestCommand } from '../model/sendFriendRequestCommand';
import { SendFriendRequestResult } from '../model/sendFriendRequestResult';
import { SuspendOwnerChatCommand } from '../model/suspendOwnerChatCommand';
import { UpdateChatReportStatusCommand } from '../model/updateChatReportStatusCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class FriendsService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsBlockUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsBlockUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsBlockUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsBlockUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling friendsBlockUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Friends/Block/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsBlockUidPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsBlockUidPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsBlockUidPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsBlockUidPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling friendsBlockUidPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Friends/Block/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsBlockedGet(observe?: 'body', reportProgress?: boolean): Observable<GetBlockedUsersResult>;
    public friendsBlockedGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetBlockedUsersResult>>;
    public friendsBlockedGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetBlockedUsersResult>>;
    public friendsBlockedGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetBlockedUsersResult>('get',`${this.basePath}/Friends/Blocked`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsCountGet(observe?: 'body', reportProgress?: boolean): Observable<GetFriendCountResult>;
    public friendsCountGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetFriendCountResult>>;
    public friendsCountGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetFriendCountResult>>;
    public friendsCountGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetFriendCountResult>('get',`${this.basePath}/Friends/Count`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param search 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsGet(search?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<GetFriendsResult>;
    public friendsGet(search?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetFriendsResult>>;
    public friendsGet(search?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetFriendsResult>>;
    public friendsGet(search?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('Search', <any>search);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetFriendsResult>('get',`${this.basePath}/Friends`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ownerUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsOwnersOwnerUidChatSuspendDelete(ownerUid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsOwnersOwnerUidChatSuspendDelete(ownerUid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsOwnersOwnerUidChatSuspendDelete(ownerUid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsOwnersOwnerUidChatSuspendDelete(ownerUid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ownerUid === null || ownerUid === undefined) {
            throw new Error('Required parameter ownerUid was null or undefined when calling friendsOwnersOwnerUidChatSuspendDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Friends/Owners/${encodeURIComponent(String(ownerUid))}/Chat/Suspend`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ownerUid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsOwnersOwnerUidChatSuspendPost(ownerUid: string, body?: SuspendOwnerChatCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsOwnersOwnerUidChatSuspendPost(ownerUid: string, body?: SuspendOwnerChatCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsOwnersOwnerUidChatSuspendPost(ownerUid: string, body?: SuspendOwnerChatCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsOwnersOwnerUidChatSuspendPost(ownerUid: string, body?: SuspendOwnerChatCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (ownerUid === null || ownerUid === undefined) {
            throw new Error('Required parameter ownerUid was null or undefined when calling friendsOwnersOwnerUidChatSuspendPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Friends/Owners/${encodeURIComponent(String(ownerUid))}/Chat/Suspend`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param ownerUids 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsPresenceGet(ownerUids?: Array<string>, observe?: 'body', reportProgress?: boolean): Observable<GetPresenceResult>;
    public friendsPresenceGet(ownerUids?: Array<string>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetPresenceResult>>;
    public friendsPresenceGet(ownerUids?: Array<string>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetPresenceResult>>;
    public friendsPresenceGet(ownerUids?: Array<string>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (ownerUids) {
            ownerUids.forEach((element) => {
                queryParameters = queryParameters.append('ownerUids', <any>element);
            })
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetPresenceResult>('get',`${this.basePath}/Friends/Presence`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsReportPost(body?: ReportUserCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsReportPost(body?: ReportUserCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsReportPost(body?: ReportUserCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsReportPost(body?: ReportUserCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Friends/Report`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param conversationUid 
     * @param beforeMessageUid 
     * @param aroundMessageUid 
     * @param focusOwnerUid 
     * @param limit 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsReportsConversationsConversationUidMessagesGet(conversationUid: string, beforeMessageUid?: string, aroundMessageUid?: string, focusOwnerUid?: string, limit?: number, observe?: 'body', reportProgress?: boolean): Observable<GetReportConversationMessagesResult>;
    public friendsReportsConversationsConversationUidMessagesGet(conversationUid: string, beforeMessageUid?: string, aroundMessageUid?: string, focusOwnerUid?: string, limit?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetReportConversationMessagesResult>>;
    public friendsReportsConversationsConversationUidMessagesGet(conversationUid: string, beforeMessageUid?: string, aroundMessageUid?: string, focusOwnerUid?: string, limit?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetReportConversationMessagesResult>>;
    public friendsReportsConversationsConversationUidMessagesGet(conversationUid: string, beforeMessageUid?: string, aroundMessageUid?: string, focusOwnerUid?: string, limit?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (conversationUid === null || conversationUid === undefined) {
            throw new Error('Required parameter conversationUid was null or undefined when calling friendsReportsConversationsConversationUidMessagesGet.');
        }





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (beforeMessageUid !== undefined && beforeMessageUid !== null) {
            queryParameters = queryParameters.set('beforeMessageUid', <any>beforeMessageUid);
        }
        if (aroundMessageUid !== undefined && aroundMessageUid !== null) {
            queryParameters = queryParameters.set('aroundMessageUid', <any>aroundMessageUid);
        }
        if (focusOwnerUid !== undefined && focusOwnerUid !== null) {
            queryParameters = queryParameters.set('focusOwnerUid', <any>focusOwnerUid);
        }
        if (limit !== undefined && limit !== null) {
            queryParameters = queryParameters.set('limit', <any>limit);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetReportConversationMessagesResult>('get',`${this.basePath}/Friends/Reports/Conversations/${encodeURIComponent(String(conversationUid))}/Messages`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param pageNumber 
     * @param pageSize 
     * @param status 
     * @param reporterUid 
     * @param reportedOwnerUid 
     * @param conversationUid 
     * @param reason 
     * @param search 
     * @param createdFromUtc 
     * @param createdToUtc 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsReportsGet(pageNumber?: number, pageSize?: number, status?: ChatReportStatus, reporterUid?: string, reportedOwnerUid?: string, conversationUid?: string, reason?: string, search?: string, createdFromUtc?: Date, createdToUtc?: Date, observe?: 'body', reportProgress?: boolean): Observable<GetChatReportsResult>;
    public friendsReportsGet(pageNumber?: number, pageSize?: number, status?: ChatReportStatus, reporterUid?: string, reportedOwnerUid?: string, conversationUid?: string, reason?: string, search?: string, createdFromUtc?: Date, createdToUtc?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetChatReportsResult>>;
    public friendsReportsGet(pageNumber?: number, pageSize?: number, status?: ChatReportStatus, reporterUid?: string, reportedOwnerUid?: string, conversationUid?: string, reason?: string, search?: string, createdFromUtc?: Date, createdToUtc?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetChatReportsResult>>;
    public friendsReportsGet(pageNumber?: number, pageSize?: number, status?: ChatReportStatus, reporterUid?: string, reportedOwnerUid?: string, conversationUid?: string, reason?: string, search?: string, createdFromUtc?: Date, createdToUtc?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {











        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('Status', <any>status);
        }
        if (reporterUid !== undefined && reporterUid !== null) {
            queryParameters = queryParameters.set('ReporterUid', <any>reporterUid);
        }
        if (reportedOwnerUid !== undefined && reportedOwnerUid !== null) {
            queryParameters = queryParameters.set('ReportedOwnerUid', <any>reportedOwnerUid);
        }
        if (conversationUid !== undefined && conversationUid !== null) {
            queryParameters = queryParameters.set('ConversationUid', <any>conversationUid);
        }
        if (reason !== undefined && reason !== null) {
            queryParameters = queryParameters.set('Reason', <any>reason);
        }
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('Search', <any>search);
        }
        if (createdFromUtc !== undefined && createdFromUtc !== null) {
            queryParameters = queryParameters.set('CreatedFromUtc', <any>createdFromUtc.toISOString());
        }
        if (createdToUtc !== undefined && createdToUtc !== null) {
            queryParameters = queryParameters.set('CreatedToUtc', <any>createdToUtc.toISOString());
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetChatReportsResult>('get',`${this.basePath}/Friends/Reports`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param reportUid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsReportsReportUidBlockPost(reportUid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsReportsReportUidBlockPost(reportUid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsReportsReportUidBlockPost(reportUid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsReportsReportUidBlockPost(reportUid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reportUid === null || reportUid === undefined) {
            throw new Error('Required parameter reportUid was null or undefined when calling friendsReportsReportUidBlockPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Friends/Reports/${encodeURIComponent(String(reportUid))}/Block`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param reportUid 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsReportsReportUidStatusPost(reportUid: string, body?: UpdateChatReportStatusCommand, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsReportsReportUidStatusPost(reportUid: string, body?: UpdateChatReportStatusCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsReportsReportUidStatusPost(reportUid: string, body?: UpdateChatReportStatusCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsReportsReportUidStatusPost(reportUid: string, body?: UpdateChatReportStatusCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (reportUid === null || reportUid === undefined) {
            throw new Error('Required parameter reportUid was null or undefined when calling friendsReportsReportUidStatusPost.');
        }


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<any>('post',`${this.basePath}/Friends/Reports/${encodeURIComponent(String(reportUid))}/Status`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsRequestsGet(observe?: 'body', reportProgress?: boolean): Observable<GetFriendRequestsResult>;
    public friendsRequestsGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<GetFriendRequestsResult>>;
    public friendsRequestsGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<GetFriendRequestsResult>>;
    public friendsRequestsGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<GetFriendRequestsResult>('get',`${this.basePath}/Friends/Requests`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsRequestsPost(body?: SendFriendRequestCommand, observe?: 'body', reportProgress?: boolean): Observable<SendFriendRequestResult>;
    public friendsRequestsPost(body?: SendFriendRequestCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SendFriendRequestResult>>;
    public friendsRequestsPost(body?: SendFriendRequestCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SendFriendRequestResult>>;
    public friendsRequestsPost(body?: SendFriendRequestCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SendFriendRequestResult>('post',`${this.basePath}/Friends/Requests`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsRequestsUidAcceptPost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsRequestsUidAcceptPost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsRequestsUidAcceptPost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsRequestsUidAcceptPost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling friendsRequestsUidAcceptPost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Friends/Requests/${encodeURIComponent(String(uid))}/Accept`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsRequestsUidDeclinePost(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsRequestsUidDeclinePost(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsRequestsUidDeclinePost(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsRequestsUidDeclinePost(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling friendsRequestsUidDeclinePost.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('post',`${this.basePath}/Friends/Requests/${encodeURIComponent(String(uid))}/Decline`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsRequestsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsRequestsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsRequestsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsRequestsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling friendsRequestsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Friends/Requests/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param search 
     * @param pageNumber 
     * @param pageSize 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsSearchGet(search?: string, pageNumber?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<SearchFriendsResult>;
    public friendsSearchGet(search?: string, pageNumber?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SearchFriendsResult>>;
    public friendsSearchGet(search?: string, pageNumber?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SearchFriendsResult>>;
    public friendsSearchGet(search?: string, pageNumber?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('Search', <any>search);
        }
        if (pageNumber !== undefined && pageNumber !== null) {
            queryParameters = queryParameters.set('PageNumber', <any>pageNumber);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('PageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<SearchFriendsResult>('get',`${this.basePath}/Friends/Search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param uid 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public friendsUidDelete(uid: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public friendsUidDelete(uid: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public friendsUidDelete(uid: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public friendsUidDelete(uid: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (uid === null || uid === undefined) {
            throw new Error('Required parameter uid was null or undefined when calling friendsUidDelete.');
        }

        let headers = this.defaultHeaders;

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('delete',`${this.basePath}/Friends/${encodeURIComponent(String(uid))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
